/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check_circle': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle pid="0" cx="16" cy="16" r="13" _fill="#0B2C62"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M22.232 12.309a1 1 0 01-.035 1.414l-7.347 6.994a1 1 0 01-1.379 0L9.768 17.19a1 1 0 011.38-1.448l3.013 2.87 6.657-6.338a1 1 0 011.414.035z" _fill="#fff"/>'
  }
})
